<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/global-bg.png" />
    <div>
      <div class="list no-padding">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到季度</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart05M id="global01" :datas="data01" :colors="colors" height="240px"/>
      </div>
      <div class="list">
        <div class="title-cont">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title">公司整体目标分解到月度</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
        </div>
        <Echart07M01 id="global02" :datas="data02" :items="items02" :dimensions="dimensions" height="460px" />
      </div>
    </div>
    <NavStyle :navIndex="2"></NavStyle>
  </div>
</template>

<script>
  import Echart05M from '../../components/Echart05M.vue'
  import Echart07M01 from '../../components/Echart07M01.vue'
  import NavStyle from '../../components/NavStyle.vue'
  
  export default {
    name: 'GlobalY',
    components: {
      Echart05M,
      Echart07M01,
      NavStyle
    },
    data() {
      return {
        loading: false,
        colors: [ '#2dfcff','#ffda2d','#be2dfa','#ff6f06',],
        items01: ['timeType', 'value',],
        data:[],
        // data01: [
        //   { value: 22934, name: '第一季度' },
        //   { value: 60862, name: '第二季度' },
        //   { value: 58416, name: '第三季度' },
        //   { value: 62081, name: '第四季度' }
        // ],
        items02: ['月度目标', '月度占比'],
        dimensions: ['timeType', 'value', 'ratio'],
        // data02: [
        //   {name: "1月", value1: 6075, value2: 3}, 
        //   {name: "2月", value1: 5107, value2: 2}, 
        //   {name: "3月", value1: 11752, value2: 6}, 
        //   {name: "4月", value1: 18701, value2: 9}, 
        //   {name: "5月", value1: 19573, value2: 10}, 
        //   {name: "6月", value1: 22588, value2: 11}, 
        //   {name: "7月", value1: 18371, value2: 9}, 
        //   {name: "8月", value1: 19640, value2: 10}, 
        //   {name: "9月", value1: 20405, value2: 10}, 
        //   {name: "10月", value1: 20858, value2: 10}, 
        //   {name: "11月", value1: 21811, value2: 11}, 
        //   {name: "12月", value1: 19412, value2: 10}, 
        // ].reverse()
      }
    },
    computed: {
      data01() {
        let newArr = []
        this.data.slice(12, 16).map(item => newArr.push({name: item.timeType, value: item.value}))
        return newArr
      },
      data02() {
        let newArr = []
        this.data.slice(0, 12).map(item => newArr.push({timeType: item.timeType, value: item.value, ratio: parseInt(item.ratio)}))
        return newArr.reverse()
      }
    },
    mounted() {
      this.$axios.post('/total_count/findList').then( res => {
        this.data = res.data.data
      })
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }
  
  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }
  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }
  
  .icon-cur{
    color: white;
    background-color: #1fd6d9;
  }
  
  .title-cont01 {
    margin-bottom: 20px
  }
  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }
  .echart-box > div {
    width: 50%;
  }
  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
  .no-padding {
    padding: 0 !important;
  }
</style>
